import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

/**
 * In-app route fallback.
 *
 * `LoadingScreen` is `position: fixed; inset: 0` because it is used when the whole
 * application is booting (auth check, captive portal). Using it as the Suspense
 * fallback for a section change covered the sidebar and the top bar and reset the
 * scroll position, so switching Billing -> Payments looked exactly like a browser
 * reload. This keeps the shell visible and only clears the content area.
 */
const ContentSkeleton = ({ title = 'Loading…', rows = 6 }) => (
  <Box sx={{ width: '100%' }} aria-busy="true" aria-live="polite">
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
      <Skeleton variant="rounded" width={44} height={44} />
      <Box sx={{ flexGrow: 1 }}>
        <Skeleton variant="text" width="32%" height={34} />
        <Skeleton variant="text" width="18%" height={18} />
      </Box>
    </Box>

    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2, mb: 3 }}>
      {[0, 1, 2, 3].map((index) => (
        <Skeleton key={index} variant="rounded" height={84} />
      ))}
    </Box>

    <Skeleton variant="rounded" height={48} sx={{ mb: 1.5 }} />
    {Array.from({ length: rows }).map((_, index) => (
      <Skeleton key={index} variant="text" height={38} />
    ))}

    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
      {title}
    </Typography>
  </Box>
);

export default ContentSkeleton;
